import React from "react";
import LandingPageMobile from "./LandingPageMobile";
function App() {
  return <LandingPageMobile />;
}
export default App;